import i18n from '@/locales'

export const categoryMap = {
  // serverless: i18n.t('db.text_381'),
  sharding: i18n.t('db.text_379'),
  replicate: i18n.t('db.text_380'),
}
